export type ProgressStatusType = 'IN_PROGRESS' | 'CLOSED';

export const ProgressStatusType = {
  InProgress: 'IN_PROGRESS' as ProgressStatusType,
  Closed: 'CLOSED' as ProgressStatusType,
};
